<div class="template-container">
  <form [formGroup]="templateForm" (ngSubmit)="onSubmit()">
    <div class="col-12 d-flex" *ngIf="templateForm.get('eventType')?.value !== 'autoCancel'">
      <div class="form-group col-12">
        <label for="templateScope">Template Scope</label>
        <p-dropdown [options]="templateScopes" optionLabel="label" optionValue="value" formControlName="scope"
          placeholder="Select Template Scope" id="templateScope">
        </p-dropdown>
        <div *ngIf="templateForm.controls['scope'].invalid && templateForm.controls['scope'].touched"
          class="error text-danger">
          <small class="text-danger">Template scope is required!.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex">
      <div class="form-group col-6">
        <label for="title">Title</label>
        <input id="title" type="text" pInputText formControlName="title" />
        <div *ngIf="templateForm.controls['title'].invalid && templateForm.controls['title'].touched"
          class="error text-danger">
          <small class="text-danger">Template title is required!.</small>
        </div>
      </div>
      <div class="form-group col-6">
        <label for="subject">Email Subject</label>
        <input id="subject" type="text" pInputText formControlName="subject" />
        <div *ngIf="templateForm.controls['subject'].invalid && templateForm.controls['subject'].touched"
          class="error text-danger">
          <small class="text-danger">Template subject is required!.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" *ngIf="templateForm.get('eventType')?.value !== 'autoCancel'">
      <div class="form-group col-6">
        <label for="sortId">Sort Order Number</label>
        <input id="sortId" type="number" min="1" step="1" pInputText formControlName="sortId" />
        <div *ngIf="templateForm.controls['sortId'].invalid && templateForm.controls['sortId'].touched"
          class="error text-danger">
          <small class="text-danger">Sort order number is required & must be an integer.</small>
        </div>
      </div>
      <div class="form-group col-6">
        <label for="eventType" class="mb-1">Event Type</label>
        <p-dropdown [options]="eventTypes" optionLabel="label" optionValue="value" formControlName="eventType"
          placeholder="Select Event Type" id="eventType">
        </p-dropdown>
        <div *ngIf="templateForm.controls['eventType'].invalid && templateForm.controls['eventType'].touched"
          class="error text-danger">
          <small class="text-danger">Event type is required.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" *ngIf="templateForm.get('eventType')?.value !== 'autoCancel'">
      <div class="form-group col-6">
        <label for="sendTimeCondition" class="mb-1">Event Condition</label>
        <p-dropdown [options]="eventConditions" optionLabel="label" optionValue="value"
          formControlName="sendTimeCondition" placeholder="Select Event Type" id="sendTimeCondition">
        </p-dropdown>
        <div *ngIf="templateForm.controls['sendTimeCondition'].invalid && templateForm.controls['sendTimeCondition'].touched"
          class="error text-danger">
          <small class="text-danger">Event condition is required.</small>
        </div>
      </div>
      <div class="form-group col-6">
        <label for="sendTime">Send Timing (in hours)</label>
        <input id="sendTime" type="number" min="0" step="0.1" pInputText formControlName="sendTime"/>
        <small class="text-muted" *ngIf="templateForm.get('sendTimeCondition')?.value === 'no_response'">
          Hours to wait after lead is pulled before sending (if no tour booked)
        </small>
        <div *ngIf="templateForm.controls['sendTime'].invalid && templateForm.controls['sendTime'].touched"
          class="error text-danger">
          <small class="text-danger">Send timing is required & must be a valid number.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" *ngIf="templateForm.get('eventType')?.value === 'autoCancel'">
      <div class="form-group w-100">
        <label for="autoCancelNotifyResidents">Auto-cancel Notification</label>
        <p-dropdown
          id="autoCancelNotifyResidents"
          [options]="autoCancelNotificationOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="status"
          placeholder="Select Notification Behavior">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 d-flex" *ngIf="templateForm.get('eventType')?.value == 'emailResponder'">
      <div class="form-group w-100">
        <label for="content">If Reply (Phone Number Detected)</label>
          <p-dropdown [options]="replyTypes" optionLabel="label" optionValue="value" formControlName="replyType" id="replyType"></p-dropdown>
        <div *ngIf="templateForm.controls['replyType'].invalid && templateForm.controls['replyType'].touched"
          class="error text-danger">
          <small class="text-danger">Reply type is required.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" *ngIf="templateForm.get('eventType')?.value !== 'emailResponder'">
      <div class="form-group w-100">
        <label for="content">Message Content</label>
        <textarea #messageTextarea id="content" type="text" pInputText formControlName="content" rows="5"
          class="w-100 resize" (focus)="setActiveField('content')"></textarea>
        <div *ngIf="templateForm.controls['content'].invalid && templateForm.controls['content'].touched"
          class="error text-danger">
          <small class="text-danger">Message content is required.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" *ngIf="templateForm.get('sendAsEmail')?.value">
      <div class="form-group w-100">
        <label for="emailContent">Email Content</label>
        <textarea #emailTextarea id="emailContent" type="text" pInputText formControlName="emailContent" rows="5"
          class="w-100 resize" (focus)="setActiveField('emailContent')"></textarea>
        <div *ngIf="templateForm.controls['emailContent'].invalid && templateForm.controls['emailContent'].touched"
          class="error text-danger">
          <small class="text-danger">Email content is required.</small>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex">
      <div class="form-group w-100">
        <label for="emailContent" *ngIf="templateForm.get('eventType')?.value === 'emailResponder'">Widget Event Configuration</label>
      </div>
      <div class="form-group col-6">
        <div class="d-flex justify-align-item gap-2">
        <input id="sendAsSms" type="checkbox" formControlName="sendAsSms" class="w-auto m-0"/>
        <label for="sendAsSms">Send as SMS</label>
        <div *ngIf="templateForm.controls['sendAsSms'].invalid && templateForm.controls['sendAsSms'].touched"
            class="error text-danger">
          <small class="text-danger">Please check Send as SMS.</small>
        </div>
        </div>
      </div>
      <div class="form-group col-6">
        <div class="d-flex justify-align-item gap-2">
        <input id="sendAsEmail" type="checkbox" formControlName="sendAsEmail" class="w-auto m-0"/>
        <label for="sendAsEmail">Send as Email</label>
        <div *ngIf="templateForm.controls['sendAsEmail'].invalid && templateForm.controls['sendAsEmail'].touched"
          class="error text-danger">
          <small class="text-danger">Please check Send as Email.</small>
        </div>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center" *ngIf="templateForm.errors?.['atLeastOneRequired'] && templateForm.touched && templateForm.get('eventType')?.value !== 'autoCancel'" >
      <div class="error text-danger">
        <small class="text-danger">Please check at least one - to send as (SMS or Email).</small>
      </div>
    </div>
    <div class="d-flex flex-column mt-3">
      <p class="note">
      💡 <strong>Note:</strong> Click on any variable to automatically insert it at the cursor position in the message box. These variables will be replaced with actual values when the message is sent.
      </p>
      <p class="mb-1">
        <ng-container *ngFor="let variable of showMore ? variables : variables.slice(0, 2)">
          <span class="badge mr-2" (click)="insertVariable(variable.key)"
            [innerHTML]="getVariableDisplay(variable)"></span>
        </ng-container>
        <span *ngIf="variables.length > 2" class="btn-link text-primary"
          (click)="toggleShowMore()">{{ showMore ? 'Show Less' : 'Show More' }}
        </span>
      </p>
    </div>
    <div class="d-flex justify-content-end mt-2 p-1">
      <p-button type="button" label="Cancel" class="secondary-btn" (click)="cancelAddTemplate()"></p-button>
      &nbsp;
      <p-button type="submit" [disabled]="templateForm.invalid" class="primary-btn"
        [label]="buttonLabel + ' Template'"></p-button>
    </div>
  </form>
</div>
<p-toast></p-toast>
